import { formatNumber } from './number';
/**
 * formats an internet volume for locale and unit type
 * @param {Number} volume number
 * @param {Number} number of decimals
 * @param {String} source unit
 * @returns {String} formatted volume
 */
export function formatInternet(volume, language, decimal, unit) {
    const amountAndUnit = getInternetAmountAndUnit(volume, decimal, unit);
    return formatNumber(amountAndUnit[0], language, decimal) + ' ' + amountAndUnit[1];
}
/**
 * Returns an array of 2 values, amount (number) and unit type (string)
 * @param {Number} volume number
 * @param {Number} number of decimals
 * @param {String} source unit
 * @returns {Array} array of 2 values, amount and unit associated with the amount
 */
export function getInternetAmountAndUnit(volume, decimal, unit) {
    let amount = getInternetVolume(volume, unit);
    unit = 'MB';
    decimal = decimal || 2;
    const unitLimit = 1024;
    amount = amount / unitLimit / unitLimit;
    if (amount >= unitLimit) {
        amount = amount / unitLimit;
        unit = 'GB';
    }
    if (amount >= unitLimit) {
        amount = amount / unitLimit;
        unit = 'TB';
    }
    amount = parseFloat(amount.toFixed(decimal));
    return [amount, unit];
}
export function getInternetVolume(amount, unit) {
    let volume;
    if (unit) {
        switch (unit.toLowerCase()) {
            case 'kb': {
                volume = amount * 1024;
                break;
            }
            case 'mb': {
                volume = amount * 1024 * 1024;
                break;
            }
            case 'gb': {
                volume = amount * 1024 * 1024 * 1024;
                break;
            }
            default: {
                volume = amount;
            }
        }
    }
    else {
        volume = amount;
    }
    return volume;
}
